import { type HTMLAttributes, type ReactNode } from 'react';
import ComponentHeader from 'components/headers/component-header';
import styles from './page-section.module.scss';
import Divider from '../divider';
import kebabCase from 'lodash/kebabCase';
/*
	Generic "Section" component that includes Title, Description, Link + standard "component" spacing.
*/

const PageSection = ({
	title = null,
	description = null,
	link = null,
	children,
	hasClampedWidth = true,
	hasDivider = false,
	hasTopDivider = false,
	...restProps
}: PageSectionProps) => {
	const sectionId = title ? kebabCase(title) : null;
	const classes = hasClampedWidth ? styles.clampedWidthWrapper : styles.wrapper;
	return (
		<section id={sectionId} className={classes} {...restProps}>
			{hasTopDivider && <Divider margin="var(--spacing-l)" />}
			{title || description || link ? (
				<ComponentHeader description={description} title={title} link={link} />
			) : null}
			<>{children}</>
			{hasDivider && <Divider margin="var(--spacing-l)" />}
		</section>
	);
};

export interface PageSectionProps extends HTMLAttributes<HTMLElement> {
	hasClampedWidth?: boolean;
	children: ReactNode;
	description?: string;
	link?: { cta: string; url: string };
	title?: string;
	hasDivider?: boolean;
	hasTopDivider?: boolean;
}

export default PageSection;
